<app-modal>
  <div class="modal-2xl min-640">
    <app-modal-content>
      <div class="modal-body">
        <div class="d-flex justify-content-between">
          <p class="title-m">
            {{ 'contact_details_linked_profile_modal.title_l' | translate }}
          </p>
          <div class="c-pointer">
            <img
              src="/assets/images/icons/icon-close.svg"
              (click)="closeModal()"
            />
          </div>
        </div>
        <p [ngClass]="{ 'mb-0': isLoading }">
          {{
            'contact_details_linked_profile_modal.explanatory_text_m'
              | translate
          }}
        </p>

        @if (!isLoading && (totalElements$ | async); as amount) {
          <p class="m-0">
            <b>
              {{
                (amount === 1
                  ? 'contact_details_linked_profile_modal.amount_of_coupled_contacts_m.one'
                  : 'contact_details_linked_profile_modal.amount_of_coupled_contacts_m.other'
                ) | translate: { amount: amount }
              }}
            </b>
          </p>
        }

        <app-data-table
          [sameBackgroundHeader]="false"
          [isLoading]="isLoading"
          [data]="connectedProfiles()"
          [columns]="columns"
          [highlightKey]="'mainProfile'"
        >
          <ng-template let-item appTableCell="name">
            <app-data-table-cell [clickable]="false">
              <ng-template #cellData>
                @if (item.mainProfile) {
                  <img
                    src="/assets/images/icons/icon-checkmark-thin-green.svg"
                    class="me-2"
                  />
                }
                <p class="mb-0" [ngClass]="{ 'color-green': item.mainProfile }">
                  {{ item | appFullName }}
                </p>
              </ng-template>
            </app-data-table-cell>
          </ng-template>
          <ng-template let-item appTableCell="dateOfBirth">
            <app-data-table-cell [clickable]="false">
              <ng-template #cellData>
                <p class="mb-0" [ngClass]="{ 'color-green': item.mainProfile }">
                  {{ item?.dateOfBirth | appDateTime | appHumanizeBoolean }}
                </p>
              </ng-template>
            </app-data-table-cell>
          </ng-template>
          <ng-template let-item appTableCell="membershipNumber">
            <app-data-table-cell [clickable]="false">
              <ng-template #cellData>
                <p class="mb-0" [ngClass]="{ 'color-green': item.mainProfile }">
                  {{ item?.membershipNumber | appHumanizeBoolean }}
                </p>
              </ng-template>
            </app-data-table-cell>
          </ng-template>
          <ng-template let-item appTableCell="email">
            <app-data-table-cell [clickable]="false">
              <ng-template #cellData>
                <p class="mb-0" [ngClass]="{ 'color-green': item.mainProfile }">
                  {{ item?.email | appHumanizeBoolean }}
                </p>
              </ng-template>
            </app-data-table-cell>
          </ng-template>

          <ng-template let-item appTableCell="context-menu">
            <app-data-table-cell
              [alignment]="'center'"
              [withoutPadding]="true"
              [clickable]="false"
            >
              <ng-template #cellData>
                @let isMainProfile = item.mainProfile;
                @let showContextMenu =
                  !isMainProfile ||
                  (ownershipType() === ContactOwnershipType.LANDLORD &&
                    isAllResidents() &&
                    isAdmin());
                @if (showContextMenu) {
                  <app-context-menu
                    [disabled]="item.resident"
                    [container]="'body'"
                    [buttonUseFullContainerSize]="true"
                    class="w-100 h-100"
                    [ghostButton]="true"
                    [borderRadius]="'none'"
                    [tooltipPlacement]="ContextMenuTooltipPlacementEnum.LEFT"
                  >
                    <div menu-content>
                      @if (!isMainProfile) {
                        <app-context-menu-item
                          (clickEvent)="
                            handleMarkAsMainProfileAction(item.userProfileId)
                          "
                        >
                          {{
                            'contact_details_linked_profile_modal.mark_as_main_profile_a'
                              | translate
                          }}
                        </app-context-menu-item>
                      }
                      @if (isAdmin()) {
                        <app-context-menu-item
                          [highlightTextRed]="true"
                          (clickEvent)="
                            handleSeparateProfileAction(item.userProfileId)
                          "
                        >
                          {{
                            'contact_details_linked_profile_modal.separate_profile_a'
                              | translate
                          }}
                        </app-context-menu-item>
                      }
                    </div>
                  </app-context-menu>
                } @else if (isMainProfile) {
                  <div class="d-flex">
                    <svg-icon
                      src="/assets/images/icons/icon-action-preferred.svg"
                      [applyClass]="true"
                      [svgStyle]="{ 'width.px': 20 }"
                      [ngClass]="'green-white-svg-color circle-fill path-fill'"
                      class="default-svg-color crown-icon"
                    ></svg-icon>
                  </div>
                }
              </ng-template>
            </app-data-table-cell>

            <!-- Disable for resident profiles -->
          </ng-template>
        </app-data-table>

        <br />

        <app-list-controls
          class="mt-2"
          [pageSize]="pageSize"
          [page]="page"
          [totalCount]="totalElements$ | async"
          (pageChange)="onPageChange($event)"
          (sizeChange)="onSizeChange($event)"
        ></app-list-controls>
      </div>
    </app-modal-content>
  </div>
</app-modal>
